// extracted by mini-css-extract-plugin
module.exports = {"button":"First_button__2XPsS","errorMsg":"First_errorMsg__2kAiq"};